"use strict";
var form = document.getElementById("form");
var input = document.getElementById("form_input");
form.addEventListener("submit", function(e) {
    e.preventDefault();
    input.value = "";
    input.classList.add("subscribe__input--submitted");
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});

//# sourceMappingURL=index.72974e9a.js.map
